export const UserInfoWidth = '40rem'